/**
 * @fileoverview A API do quadro compartilhado por link. Usa o axios sem os
 * interceptadores do app (openApi): o token do login de quem por acaso esteja
 * logado no mesmo navegador não vai (o cabeçalho Authorization), e um 401 aqui
 * não manda para o /login. Os cookies do domínio da API vão, porque o
 * navegador os manda sozinho (inclusive o da renovação do login), mas estas
 * rotas só leem o cookie da sessão do link. O código do link vai no cabeçalho,
 * nunca na URL.
 */

import { openApi } from "../../services/api";

export const SHARED_BOARD_PATH = "/shared/board";

const TOKEN_FORMAT = /^#?([A-Za-z0-9_-]{43})(?:$|[^A-Za-z0-9_-])/;

/** O código do link, que vem depois do "#" (nunca chega a servidor nenhum). */
export const readShareToken = (hash = window.location.hash) => {
  const match = TOKEN_FORMAT.exec(hash || "");
  return match ? match[1] : null;
};

export const isSharedBoardPath = (pathname = window.location.pathname) =>
  pathname.replace(/\/+$/, "") === SHARED_BOARD_PATH;

const headersFor = (token, extra = {}) => ({ "X-Share-Token": token, ...extra });

/** O quadro; com a ETag da última leitura, 304 quando nada mudou. */
export const fetchSharedBoard = (token, etag) =>
  openApi.get("/shared-boards/board", {
    headers: headersFor(token, etag ? { "If-None-Match": etag } : {}),
    validateStatus: (status) => (status >= 200 && status < 300) || status === 304,
  });

export const fetchSharedCard = (token, cardId) =>
  openApi.get(`/shared-boards/cards/${encodeURIComponent(cardId)}`, { headers: headersFor(token) });

export const unlockSharedBoard = (token, password) =>
  openApi.post("/shared-boards/unlock", { password }, { headers: headersFor(token) });

/** A situação do link pela resposta de erro da API. */
export const denialOf = (err) => {
  const status = err?.response?.status;
  const code = err?.response?.data?.error;
  if (status === 401 && code === "ERR_SHARE_PASSWORD_REQUIRED") return "password";
  if (status === 404 && code === "ERR_SHARE_NOT_FOUND") return "invalid";
  if (status === 410) return code === "ERR_SHARE_REVOKED" ? "revoked" : "expired";
  if (status === 403 && code === "ERR_SHARE_UNAVAILABLE") return "unavailable";
  if (status === 429) return "rateLimited";
  return "error";
};
